import { ShieldCheck, WifiOff, Languages } from "lucide-react";

import { ButtonLink } from "@/components/ui/Button";
import { PrimaryCta } from "@/components/ui/PrimaryCta";
import { AuroraField, GridField } from "@/components/visuals/AuroraField";
import { useLocale } from "@/i18n";

export function Hero() {
  const { t, path } = useLocale();

  const trust = [
    { icon: WifiOff, label: t.hero.trust.offline },
    { icon: ShieldCheck, label: t.hero.trust.onDevice },
    { icon: Languages, label: t.hero.trust.arabicFirst },
  ];

  return (
    <section className="relative overflow-hidden pt-20 pb-16 md:pt-32 md:pb-24">
      <AuroraField variant="hero" />
      <GridField />

      <div className="container-page relative">
        <div className="mx-auto max-w-3xl text-center">
          <p
            className="rise-in mb-6 inline-flex items-center gap-2 rounded-full border border-white/12 bg-white/[0.03] px-4 py-1.5 text-sm text-cream-100/70"
            style={{ animationDelay: "40ms" }}
          >
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 pulse-soft" />
            {t.hero.eyebrow}
          </p>

          <h1
            className="rise-in text-display text-4xl leading-[1.15] font-semibold sm:text-5xl md:text-6xl"
            style={{ animationDelay: "120ms" }}
          >
            {t.hero.title}
          </h1>

          <p
            className="rise-in mx-auto mt-7 max-w-2xl text-lg leading-relaxed text-cream-100/62"
            style={{ animationDelay: "200ms" }}
          >
            {t.hero.body}
          </p>

          <div
            className="rise-in mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row"
            style={{ animationDelay: "280ms" }}
          >
            <PrimaryCta size="lg" className="w-full sm:w-auto" />
            <ButtonLink
              to={path("/how-it-works")}
              variant="secondary"
              size="lg"
              className="w-full sm:w-auto"
            >
              {t.cta.secondary}
            </ButtonLink>
          </div>

          <ul
            className="rise-in mt-12 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm text-cream-100/50"
            style={{ animationDelay: "360ms" }}
          >
            {trust.map(({ icon: Icon, label }) => (
              <li key={label} className="inline-flex items-center gap-2">
                <Icon size={15} className="text-emerald-400/80" aria-hidden />
                {label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
